import { DELETE_SUPPLY_REQUEST, DELETE_SUPPLY_SUCCESS, DELETE_SUPPLY_ERROR } from "../actions/deleteSupply"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const deleteSupply = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_SUPPLY_REQUEST:
            return {
                ...state,
                loading: true
            }

        case DELETE_SUPPLY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case DELETE_SUPPLY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        default:
            return state;
    }
}

export default deleteSupply
